import { actions } from 'react-redux-form';
import { batch } from 'react-redux';
import moment from 'moment';

import {
    disputeDetailsFormModel,
    getBilledCircuitId,
    disableBilledCircuitId,
    requireBilledCircuitId,
    getDisputeType,
    getDisputeStatus,
    getInvoiceNumber,
    getMatchedCircuitId,
    disableMatchedCircuitId,
    fetchDisputeDetails,
} from "../../../../constants/model-reducers/external/invoice/dispute/dispute-details.settings";
import { httpGet, httpPost } from "../../../../utils/api.utils";
import { convertToFormatDate, convertToLocalDateToUTCDate, convertDateStringToDateFormat } from '../../../../utils/helpers.utils';
import { TRANSLATIONS } from '../../../../utils/constant.utils';
import { DISPUTE_TYPES_TEXT_ID, ERROR_TYPE } from '../../../../constants/external-constants';

export const disputeDetailsFormInitialState = disputeDetailsFormModel;

const defaultState = () => ({
    fetchFormInProgress: true,
    invoiceNumberList: [],
    billedCircuitIdList: [],
    billedCircuitIdDisabled: false,
    billedCircuitIdRequired: false,
    matchedCircuitIdList: [],
    matchedCircuitIdDisabled: true,
    matchedCircuitIdRequired: false,
    disputeTypeList: [],
    disputeStatusList: [],
    disputeDetailForm: {}
});

const initialState = defaultState();

export const disputeDetailActions = {
    saveDisputeForm: (id, validate) => async (dispatch, state) => {
        let locale = state().translation.locale;
        if (locale === null || locale === '')
            locale = TRANSLATIONS['defaultLocaleLanguage'];

        try {
            const { invoiceDisputeDetailsForm } = state().form;
            const { disputeType, disputeStatus, invoiceNumber, billedCircuitId, matchedCircuitId,
                potentialSavings, realizedSavings, dateCreated, submittedToVendorDate, vendorConfirmationDate,
                expectedResolutionDate, completedDate, creditReceivedDate, disputeId
            } = invoiceDisputeDetailsForm;

            var disputeCode = `DIS${convertToFormatDate(dateCreated, 'YYYYMMDD')}`

            var data = {
                ...invoiceDisputeDetailsForm,
                disputeType: parseInt(disputeType),
                disputeStatus: parseInt(disputeStatus),
                invoiceNumber: parseInt(invoiceNumber),
                billedCircuitId: billedCircuitId ? parseInt(billedCircuitId) : null,
                matchedCircuitId: matchedCircuitId ? parseInt(matchedCircuitId) : null,
                potentialSavings: parseFloat(potentialSavings),
                realizedSavings: parseFloat(realizedSavings),
                dateCreated: dateCreated ? moment(dateCreated).toISOString(true) : null,
                submittedToVendorDate: submittedToVendorDate ? moment(submittedToVendorDate).startOf('day').format('DD MMM YYYY') : null,
                vendorConfirmationDate: vendorConfirmationDate ? moment(vendorConfirmationDate).startOf('day').format('DD MMM YYYY') : null,
                expectedResolutionDate: expectedResolutionDate ? moment(expectedResolutionDate).startOf('day').format('DD MMM YYYY') : null,
                completedDate: completedDate ? moment(completedDate).startOf('day').format('DD MMM YYYY') : null,
                creditReceivedDate: creditReceivedDate ? moment(creditReceivedDate).startOf('day').format('DD MMM YYYY') : null,
                disputeId: !disputeId ? disputeCode : disputeId
            }

            var result = await saveDispute(id, validate, data);

            if (result.success && validate == false) {
                dispatch(actions.load("invoiceDisputeDetailsForm", invoiceDisputeDetailsForm));
            }

            return result;
        }
        catch (e) {
            return e;
        }
    },
    calculateAnnual: (model, value) => async (dispatch) => {
        const numVal = isNaN(value) || value === '' ? 0 : value;
        let annualVal = (parseFloat(numVal) * 12).toFixed(2);

        if (model == "invoiceDisputeDetailsForm.potentialSavings") {
            dispatch(actions.change('invoiceDisputeDetailsForm.annualPotentialSavings', annualVal));
        }
        else if (model == "invoiceDisputeDetailsForm.realizedSavings") {
            dispatch(actions.change('invoiceDisputeDetailsForm.annualRealizedSavings', annualVal));
        }
    },
    selectDisputeType: (model, value) => (dispatch, state) => {
        const { disputeTypeList } = state().invoiceDisputeDetails;

        return disabledRequiredBilledMatchedCircuit(dispatch, state, disputeTypeList, model, value);
    },
    getInvoiceNumber: (searchVal, propsName) => async (dispatch, state) => {
        const { invoiceNumberList } = state().invoiceDisputeDetails;

        if (invoiceNumberList !== undefined && invoiceNumberList.length > 0) {
            var obj = invoiceNumberList.find(o => o[propsName] === searchVal);

            if (obj !== undefined) {
                dispatch({ type: getInvoiceNumber, data: [] });
                return null;
            }
        }

        var result = await getInvoiceNumberDropdown(searchVal);

        if (result.isSuccess) {
            batch(() => {
                dispatch(actions.resetErrors("invoiceDisputeDetailsForm.invoiceNumberDisplay"));
                dispatch({
                    type: getInvoiceNumber,
                    data: result.data
                });
            });
            return result.data;
        }
        else {
            let locale = state().translation.locale;
            if (locale === null || locale === '')
                locale = TRANSLATIONS['defaultLocaleLanguage'];

            if (result?.messages[ERROR_TYPE.invoiceNumberNotExist]) {
                dispatch(actions.setErrors("invoiceDisputeDetailsForm.invoiceNumberDisplay", TRANSLATIONS[locale]["error_invoice_number_not_exist"]));
            }
            
            return null;
        }
        
    },
    selectInvoiceNumber: (value, propsName) => async (dispatch, state) => {
        const { invoiceNumberList } = state().invoiceDisputeDetails;

        if (value == '' || invoiceNumberList?.length === 0) {
            batch(() => {
                resetInvoiceNumber(dispatch);
                resetBilledCircuitId(dispatch);
                resetMatchedCircuitId(dispatch);
            });
        }
        else {
            const invoice = invoiceNumberList.find(r => r[propsName] == value);

            if (invoice) {
                batch(() => {
                    dispatch(actions.change('invoiceDisputeDetailsForm.invoiceNumberDisplay', value));
                    dispatch(actions.change('invoiceDisputeDetailsForm.invoiceNumber', invoice.InvoiceId));
                    dispatch(actions.change('invoiceDisputeDetailsForm.accountNumber', invoice.AccountNumber));
                    dispatch(actions.change('invoiceDisputeDetailsForm.vendor', invoice.Vendor));
                    dispatch(actions.change('invoiceDisputeDetailsForm.country', invoice.Country));
                    dispatch(actions.change('invoiceDisputeDetailsForm.invoiceDate', invoice.InvoiceDate ? convertToLocalDateToUTCDate(invoice.InvoiceDate, false) : ''));
                    dispatch(actions.change('invoiceDisputeDetailsForm.actualInvoiceMonth', invoice.ActualInvoiceMonth ? convertToLocalDateToUTCDate(invoice.ActualInvoiceMonth, false): ''));

                    resetBilledCircuitId(dispatch);
                    resetMatchedCircuitId(dispatch);
                });
            }
            else {
                batch(() => {
                    resetInvoiceNumber(dispatch);
                    resetBilledCircuitId(dispatch);
                    resetMatchedCircuitId(dispatch);

                    dispatch(actions.change('invoiceDisputeDetailsForm.invoiceNumberDisplay', value));
                })
            }
        }
    },
    getBilledCircuitId: (invoiceId, searchVal, propsName) => async (dispatch, state) => {
        const { billedCircuitIdList } = state().invoiceDisputeDetails;

        if (billedCircuitIdList !== undefined && billedCircuitIdList.length > 0) {
            var obj = billedCircuitIdList.find(o => o[propsName] === searchVal);

            if (obj !== undefined) {
                dispatch({ type: getBilledCircuitId, data: [] });
                return null;
            }
        }

        var result = await getBilledCircuitIdDropdown(invoiceId, searchVal);

        if (result.isSuccess) {
            batch(() => {
                dispatch(actions.resetErrors("invoiceDisputeDetailsForm.billedCircuitIdDisplay"));
                dispatch({
                    type: getBilledCircuitId,
                    data: result.data
                });
            });
            return result.data;
        }
        else {
            let locale = state().translation.locale;
            if (locale === null || locale === '')
                locale = TRANSLATIONS['defaultLocaleLanguage'];

            if (result?.messages[ERROR_TYPE.billedCircuitIdNotExist]) {
                dispatch(actions.setErrors("invoiceDisputeDetailsForm.billedCircuitIdDisplay", TRANSLATIONS[locale]["error_billed_circuit_not_exist"]));
            }

            return null;
        }
    },
    selectBilledCircuit: (value, propsName) => (dispatch, state) => {
        const { billedCircuitIdList, matchedCircuitIdDisabled } = state().invoiceDisputeDetails;

        if (value == '' || billedCircuitIdList?.length === 0) {
            batch(() => {
                resetBilledCircuitId(dispatch);
                resetMatchedCircuitId(dispatch);
            });
        }
        else {
            const billedCircuit = billedCircuitIdList.find(r => r[propsName] == value);
            setBilledCircuit(dispatch, billedCircuit, matchedCircuitIdDisabled, value);

            return billedCircuit;
        }
    },
    getMatchedCircuitId: (invoiceId, searchVal, propsName) => async (dispatch, state) => {
        const { matchedCircuitIdList } = state().invoiceDisputeDetails;

        if (matchedCircuitIdList !== undefined && matchedCircuitIdList.length > 0) {
            var obj = matchedCircuitIdList.find(o => o[propsName] === searchVal);

            if (obj !== undefined) {
                dispatch({ type: getMatchedCircuitId, data: [] });
                return null;
            }
        }

        var result = await getMatchedCircuitIdDropdown(invoiceId, searchVal);

        if (result.isSuccess) {
            batch(() => {
                dispatch(actions.resetErrors("invoiceDisputeDetailsForm.matchedCircuitIdDisplay"));
                dispatch({
                    type: getMatchedCircuitId,
                    data: result.data
                });
            });
            return result.data;
        }
        else {
            let locale = state().translation.locale;
            if (locale === null || locale === '')
                locale = TRANSLATIONS['defaultLocaleLanguage'];

            if (result?.messages[ERROR_TYPE.matchedCircuitIdNotExist]) {
                dispatch(actions.setErrors("invoiceDisputeDetailsForm.matchedCircuitIdDisplay", TRANSLATIONS[locale]["error_matched_circuit_not_exist"]));
            }

            return null;
        }
    },
    selectMatchedCircuit: (value, propsName) => async (dispatch, state) => {
        const { matchedCircuitIdList } = state().invoiceDisputeDetails;


        if (value == '' || matchedCircuitIdList?.length === 0) {
            batch(() => {
                resetMatchedCircuitId(dispatch);
            });
        }
        else {
            const matchedCircuit = matchedCircuitIdList.find(r => r[propsName] == value);
            setMatchedCircuit(dispatch, matchedCircuit, value);
        }
    },
    getDisputeType: () => async (dispatch) => {
        var data = await getDisputeTypeDropdown();

        dispatch({
            type: getDisputeType,
            data: data
        });
    },
    getDisputeStatus: () => async (dispatch) => {
        var data = await getDisputeStatusDropdown();

        dispatch({
            type: getDisputeStatus,
            data: data
        });
    },
    getDisputeDetailForm: (disputeId, invoiceAuditId) => async (dispatch, state) => {
        var disputeStatuses = await getDisputeStatusDropdown();
        var disputeTypes = await getDisputeTypeDropdown();

        var employee = JSON.parse(sessionStorage.getItem('User')).Employee;
        const currentDateTime = new Date();
        const newDate = new Date(`${currentDateTime.getFullYear()}-${currentDateTime.getMonth() + 1}-${currentDateTime.getDate()}`)

        if (!disputeId & !invoiceAuditId) {
            batch(() => {
                dispatch({ type: getDisputeStatus, data: disputeStatuses });
                dispatch({ type: getDisputeType, data: disputeTypes });
                dispatch(actions.change('invoiceDisputeDetailsForm.createdBy', employee?.Email));
                dispatch(actions.change('invoiceDisputeDetailsForm.dateCreated', newDate));

                dispatch({ type: fetchDisputeDetails, data: false });
            });
        }
        else {
            var data = invoiceAuditId !== 0 && !disputeId ? await getInvoiceAuditDetails(invoiceAuditId) : await getDisputeDetails(disputeId);

            if (data) {
                batch(() => {
                    dispatch({ type: getDisputeStatus, data: disputeStatuses });
                    dispatch({ type: getDisputeType, data: disputeTypes });

                    dispatch(actions.load('invoiceDisputeDetailsForm.id', data.Id));
                    dispatch(actions.load('invoiceDisputeDetailsForm.disputeId', data.DisputeCode));
                    dispatch(actions.load('invoiceDisputeDetailsForm.disputeType', data.DisputeTypeId));
                    dispatch(actions.load('invoiceDisputeDetailsForm.disputeStatus', data.DisputeStatusId));
                    dispatch(actions.load('invoiceDisputeDetailsForm.createdBy', data.CreatedBy));
                    dispatch(actions.load('invoiceDisputeDetailsForm.invoiceNumberDisplay', data.Invoice.InvoiceNumber));
                    dispatch(actions.load('invoiceDisputeDetailsForm.invoiceNumber', data.Invoice.InvoiceId));
                    dispatch(actions.load('invoiceDisputeDetailsForm.accountNumber', data.Invoice.AccountNumber));
                    dispatch(actions.load('invoiceDisputeDetailsForm.vendor', data.Invoice.Vendor));
                    dispatch(actions.load('invoiceDisputeDetailsForm.country', data.Invoice.Country));
                    dispatch(actions.load('invoiceDisputeDetailsForm.invoiceDate', data.Invoice.InvoiceDate ? new Date(data.Invoice.InvoiceDate) : ''));
                    dispatch(actions.load('invoiceDisputeDetailsForm.actualInvoiceMonth', data.Invoice.ActualInvoiceMonth ? convertDateStringToDateFormat(data.Invoice.ActualInvoiceMonth, false) : ''));
                    dispatch(actions.load('invoiceDisputeDetailsForm.potentialSavings', (data.PotentialSavings ?? 0).toFixed(2)));
                    dispatch(actions.load('invoiceDisputeDetailsForm.annualPotentialSavings', (data.AnnualPotentialSavings ?? 0).toFixed(2)));
                    dispatch(actions.load('invoiceDisputeDetailsForm.realizedSavings', (data.RealizedSavings ?? 0).toFixed(2)));
                    dispatch(actions.load('invoiceDisputeDetailsForm.annualRealizedSavings', (data.AnnualRealizedSavings ?? 0).toFixed(2)));
                    dispatch(actions.load('invoiceDisputeDetailsForm.dateCreated', data.DateCreated ? convertDateStringToDateFormat(data.DateCreated, false) : ''));
                    dispatch(actions.load('invoiceDisputeDetailsForm.submittedToVendorDate', data.SubmittedToVendorDate ? convertDateStringToDateFormat(data.SubmittedToVendorDate, false) : ''));
                    dispatch(actions.load('invoiceDisputeDetailsForm.vendorConfirmationDate', data.VendorConfirmationDate ? convertDateStringToDateFormat(data.VendorConfirmationDate, false) : ''));
                    dispatch(actions.load('invoiceDisputeDetailsForm.expectedResolutionDate', data.ExpectedResolutionDate ? convertDateStringToDateFormat(data.ExpectedResolutionDate, false) : ''));
                    dispatch(actions.load('invoiceDisputeDetailsForm.completedDate', data.CompletedDate ? convertDateStringToDateFormat(data.CompletedDate, false) : ''));
                    dispatch(actions.load('invoiceDisputeDetailsForm.creditReceivedDate', data.CreditReceivedDate ? convertDateStringToDateFormat(data.CreditReceivedDate, false) : ''));
                    dispatch(actions.load('invoiceDisputeDetailsForm.additionalInformation', data.AdditionalInformation));
                    dispatch(actions.load('invoiceDisputeDetailsForm.matchedCircuitIdDisplay', data?.BilledCircuit?.MatchedCircuitCode));

                    const billedCircuitDisabledRequired = disabledRequiredBilledMatchedCircuit(dispatch, state, disputeTypes, "invoiceDisputeDetailsForm.disputeType", data.DisputeTypeId);
                    const matchedCircuitIdDisabled = !billedCircuitDisabledRequired.billedCircuitIdDisabled;

                    if (data.BilledCircuit) {
                        if (data.BilledCircuit.CircuitCode) {
                            dispatch(actions.load('invoiceDisputeDetailsForm.billedCircuitIdDisplay', data.BilledCircuit.CircuitCode));
                            dispatch(actions.load('invoiceDisputeDetailsForm.billedCircuitId', data.BilledCircuit.LineItemId));
                            dispatch(actions.load('invoiceDisputeDetailsForm.amountCharged', (data.BilledCircuit?.AmountCharged ?? 0).toFixed(2)));
                        }

                        if (matchedCircuitIdDisabled == true && data.BilledCircuit.MatchedCircuitCode) {
                            dispatch(actions.load('invoiceDisputeDetailsForm.matchedCircuitIdDisplay', data.BilledCircuit.MatchedCircuitCode));
                            dispatch(actions.load('invoiceDisputeDetailsForm.matchedCircuitId', data.BilledCircuit.MatchedCircuitId));
                            dispatch(actions.load('invoiceDisputeDetailsForm.mrc', (data.BilledCircuit?.MatchedCircuitMRC ?? 0).toFixed(2)))
                        }
                    }

                    if (data.MatchedCircuit && matchedCircuitIdDisabled == false && data.MatchedCircuit.CircuitCode) {
                        dispatch(actions.load('invoiceDisputeDetailsForm.matchedCircuitIdDisplay', data.MatchedCircuit.CircuitCode));
                        dispatch(actions.load('invoiceDisputeDetailsForm.matchedCircuitId', data.MatchedCircuit.CircuitId));
                        dispatch(actions.load('invoiceDisputeDetailsForm.mrc', (data.MatchedCircuit?.MRC ?? 0).toFixed(2)));
                    }
                    dispatch({ type: fetchDisputeDetails, data: false });
                });
                if (invoiceAuditId != null && !disputeId) {
                    dispatch(actions.load('invoiceDisputeDetailsForm.createdBy', employee?.Email));
                    dispatch(actions.load('invoiceDisputeDetailsForm.dateCreated', newDate));
                }
                return data;
            }
        }
    },
    resetDisputeDetailsForm: () => (dispatch) => {
        batch(() => {
            dispatch(actions.load("invoiceDisputeDetailsForm", disputeDetailsFormInitialState));
            dispatch(actions.reset("invoiceDisputeDetailsForm"));
            dispatch({ type: fetchDisputeDetails, data: true });
        });
    },
}

function setBilledCircuit(dispatch, billedCircuit, matchedCircuitIdDisabled, value) {
    if (billedCircuit) {
        batch(() => {
            dispatch(actions.change('invoiceDisputeDetailsForm.billedCircuitIdDisplay', value));
            dispatch(actions.change('invoiceDisputeDetailsForm.billedCircuitId', billedCircuit.LineItemId));
            dispatch(actions.change('invoiceDisputeDetailsForm.amountCharged', (billedCircuit.AmountCharged ?? 0).toFixed(2)));

            if (matchedCircuitIdDisabled == true && billedCircuit.MatchedCircuitCode) {
                dispatch(actions.change('invoiceDisputeDetailsForm.matchedCircuitId', billedCircuit.MatchedCircuitId));
                dispatch(actions.change('invoiceDisputeDetailsForm.matchedCircuitIdDisplay', billedCircuit.MatchedCircuitCode));
                dispatch(actions.change('invoiceDisputeDetailsForm.mrc', (billedCircuit.MatchedCircuitMRC ?? 0).toFixed(2)));
            }
        });
    }
    else {
        batch(() => {
            resetBilledCircuitId(dispatch);
            resetMatchedCircuitId(dispatch);

            dispatch(actions.change('invoiceDisputeDetailsForm.billedCircuitIdDisplay', value));
        })
    }
}

function resetBilledCircuitId(dispatch) {
    dispatch(actions.change("invoiceDisputeDetailsForm.billedCircuitIdDisplay", disputeDetailsFormInitialState.billedCircuitIdDisplay));
    dispatch(actions.change("invoiceDisputeDetailsForm.billedCircuitId", disputeDetailsFormInitialState.billedCircuitId));
    dispatch(actions.change("invoiceDisputeDetailsForm.amountCharged", disputeDetailsFormInitialState.amountCharged));
    dispatch(actions.resetErrors("invoiceDisputeDetailsForm.billedCircuitIdDisplay"));
}

function setMatchedCircuit(dispatch, matchedCircuit, value) {
    if (matchedCircuit) {
        batch(() => {
            dispatch(actions.change('invoiceDisputeDetailsForm.matchedCircuitIdDisplay', value));
            dispatch(actions.change('invoiceDisputeDetailsForm.matchedCircuitId', matchedCircuit.CircuitId));
            dispatch(actions.change('invoiceDisputeDetailsForm.mrc', (matchedCircuit.MRC ?? 0).toFixed(2)));
        });
    }
    else {
        batch(() => {
            resetMatchedCircuitId();

            dispatch(actions.change('invoiceDisputeDetailsForm.matchedCircuitIdDisplay', value));
        })
    }
}

function resetMatchedCircuitId(dispatch) {
    dispatch(actions.change('invoiceDisputeDetailsForm.matchedCircuitIdDisplay', disputeDetailsFormInitialState.matchedCircuitIdDisplay));
    dispatch(actions.change('invoiceDisputeDetailsForm.matchedCircuitId', disputeDetailsFormInitialState.matchedCircuitId));
    dispatch(actions.change('invoiceDisputeDetailsForm.mrc', disputeDetailsFormInitialState.mrc));
    dispatch(actions.resetErrors("invoiceDisputeDetailsForm.matchedCircuitIdDisplay"));
}

function resetInvoiceNumber(dispatch) {
    dispatch(actions.change('invoiceDisputeDetailsForm.invoiceNumberDisplay', disputeDetailsFormInitialState.invoiceNumberDisplay));
    dispatch(actions.change('invoiceDisputeDetailsForm.invoiceNumber', disputeDetailsFormInitialState.invoiceNumber));
    dispatch(actions.change('invoiceDisputeDetailsForm.accountNumber', disputeDetailsFormInitialState.accountNumber));
    dispatch(actions.change('invoiceDisputeDetailsForm.vendor', disputeDetailsFormInitialState.vendor));
    dispatch(actions.change('invoiceDisputeDetailsForm.country', disputeDetailsFormInitialState.country));
    dispatch(actions.change('invoiceDisputeDetailsForm.invoiceDate', disputeDetailsFormInitialState.invoiceDate));
    dispatch(actions.change('invoiceDisputeDetailsForm.actualInvoiceMonth', disputeDetailsFormInitialState.actualInvoiceMonth));
}

async function getInvoiceNumberDropdown(searchVal) {
    try {
        var result = await httpGet(`external/dispute/invoice-number-dropdown?searchVal=${searchVal ?? ''}`);

        return result;
    }
    catch (e) {
        return {
            data: []
        };
    }
}

async function getBilledCircuitIdDropdown(invoiceId, searchVal) {
    try {
        var result = await httpGet(`external/dispute/billed-circuits-dropdown/${invoiceId ?? 0}?searchVal=${searchVal ?? ''}`);

        return result;
    }
    catch (e) {
        return {
            data: []
        };
    }
}

async function getMatchedCircuitIdDropdown(invoiceId, searchVal) {
    try {
        var result = await httpGet(`external/dispute/matched-circuits-dropdown/${invoiceId ?? 0}?searchVal=${searchVal ?? ''}`);

        return result;
    }
    catch (e) {
        return {
            data: []
        };
    }
}

async function getDisputeTypeDropdown() {
    try {
        var result = await httpGet('external/dispute/dispute-types-dropdown');

        return result.data;
    }
    catch (e) {
        return [];
    }
}

async function getDisputeStatusDropdown() {
    try {
        var result = await httpGet('external/dispute/dispute-status-dropdown');

        return result.data;
    }
    catch (e) {
        return [];
    }
}

async function getDisputeDetails(disputeId) {
    try {
        var result = await httpGet(`external/dispute/details/${disputeId ?? 0}`);

        return result.data;
    }
    catch (e) {
        return {};
    }
}

async function getInvoiceAuditDetails(invoiceId) {
    try {
        var result = await httpGet(`external/dispute/invoiceaudit/${invoiceId ?? 0}`);

        return result.data;
    }
    catch (e) {
        return {};
    }
}

async function saveDispute(disputeId, validate, data) {
    try {
        var result = await httpPost(`external/dispute/save/${disputeId ?? 0}/${validate ?? 0}`, data);

        if (result.ok == false) {
            throw {
                success: false,
                message: "Dispute is not saved. Error encountered while on saving."
            };
        }
        return result;
    }
    catch (e) {
        throw e;
    }
}

function disabledRequiredBilledMatchedCircuit(dispatch, state, disputeTypeList, disputeTypeModel, value) {
    const { billedCircuitIdDisabled, matchedCircuitIdDisabled } = state().invoiceDisputeDetails;

    let newBilledCircuitIdDisabled = false;
    const selectedDisputeType = disputeTypeList.find(r => r.Id == value);
    const selectedTextId = selectedDisputeType?.TextId;

    if (selectedTextId == DISPUTE_TYPES_TEXT_ID.unbilledCircuit) {
        newBilledCircuitIdDisabled = true;
    }

    let billedCircuitIdRequired = false;

    const requiredTypes = [
        DISPUTE_TYPES_TEXT_ID.circuitNotFound,
        DISPUTE_TYPES_TEXT_ID.billingAccountMismatch,
        DISPUTE_TYPES_TEXT_ID.ceasedButCharging,
        DISPUTE_TYPES_TEXT_ID.differentProvider,
        DISPUTE_TYPES_TEXT_ID.mrcMismatch,
        DISPUTE_TYPES_TEXT_ID.discountNotApplied,
        DISPUTE_TYPES_TEXT_ID.firstBill,
        DISPUTE_TYPES_TEXT_ID.rateCard
    ];

    if (requiredTypes.includes(selectedTextId)) {
        billedCircuitIdRequired = true;
    }

    let newMatchedCircuitIdDisabled = !newBilledCircuitIdDisabled;

    batch(() => {
        if (billedCircuitIdDisabled !== newBilledCircuitIdDisabled && newBilledCircuitIdDisabled === true) {
            resetBilledCircuitId(dispatch);
            resetMatchedCircuitId(dispatch);
        }
        else if (matchedCircuitIdDisabled != newMatchedCircuitIdDisabled && newMatchedCircuitIdDisabled == true) {
            resetMatchedCircuitId(dispatch);
        }

        dispatch(actions.change(disputeTypeModel, value));
        dispatch({
            type: disableBilledCircuitId,
            data: newBilledCircuitIdDisabled
        });
        dispatch({
            type: requireBilledCircuitId,
            data: billedCircuitIdRequired
        });
        dispatch({
            type: disableMatchedCircuitId,
            data: newMatchedCircuitIdDisabled
        });
    });

    return {
        billedCircuitIdRequired: billedCircuitIdRequired,
        billedCircuitIdDisabled: newBilledCircuitIdDisabled,
        matchedCircuitIdDisabled: newMatchedCircuitIdDisabled
    };
}

export const reducer = (state, action) => {
    state = state || initialState;

    switch (action.type) {
        case getInvoiceNumber:
            return {
                ...state,
                invoiceNumberList: action.data
            };
        case getBilledCircuitId:
            return {
                ...state,
                billedCircuitIdList: action.data
            };
        case getMatchedCircuitId:
            return {
                ...state,
                matchedCircuitIdList: action.data
            };
        case getDisputeType:
            return {
                ...state,
                disputeTypeList: action.data
            };
        case getDisputeStatus:
            return {
                ...state,
                disputeStatusList: action.data
            };
        case disableBilledCircuitId:
            return {
                ...state,
                billedCircuitIdDisabled: action.data
            };
        case requireBilledCircuitId:
            return {
                ...state,
                billedCircuitIdRequired: action.data
            };
        case disableMatchedCircuitId: {
            return {
                ...state,
                matchedCircuitIdDisabled: action.data,
                matchedCircuitIdRequired: !action.data
            };
        }
        case fetchDisputeDetails: {
            return {
                ...state,
                fetchFormInProgress: action.data
            };
        }
        default:
            return state;
    }
}